export default "__VITE_ASSET__420f920b__"